//--------------------------------------------
//
// Handles all sound plays
//
//--------------------------------------------

'use strict';

import {Howl, Howler} from 'howler';



const AudioManager = {

	message: null,
	startup: null,
	notification: null,
	notificationClick: null,

	init: function(){

		this.startup = new Howl({
			urls: ['data/pad_glow_welcome2.wav']
		});

		this.notificationClick = new Howl({
			urls: ['data/chime_dim.wav']
		});

		this.notification = new Howl({
			urls: ['data/chime_clickbell_note.wav'],
			volume: 0.3
		});

		this.message = new Howl({
			urls: ['data/music_vibelong_chord_up.wav'],
			volume: 0.3
		});

		this.messageTurn = new Howl({
			urls: ['data/pop_waterdrip_hi.wav'],
			volume: 0.3
		});

		this.messageOff = new Howl({
			urls: ['data/etc_woosh_tech.wav'],
			volume: 0.3
		});
	},


	onStartup: function(){
		this.startup.play();
	},

	onNotificationClick: function(){
		this.notificationClick.play();
	},

	onNotification: function(){
		if (this.notification){
			this.notification.play();
		}
		
	},

	onMessage: function(){
		if (this.message){
			this.message.play();
		}
	},

	onMessageTurn: function(){
		if (this.messageTurn){
			this.messageTurn.play();
		}
	},

	onMessageOff: function(){
		if (this.messageOff){
			this.messageOff.play();
		}
	},


	mute: function(){
		Howler.mute();
	},

	unmute: function(){
		Howler.unmute();
	}



}

export default AudioManager;